
    import {Component, Vue} from 'vue-property-decorator';
    import {userApi} from "@/api/organization";
    import {inspectionUrl} from "@/constants";
    @Component
    export default class Home extends Vue {
        title = "外部调用";
        url = ""
        screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)

        created(){
            const urlFalse = this.$route.params.url;
            const uArr = urlFalse.split('$');
            let uArr1 = '';
            if (uArr[0] === 'inspection') {
                uArr1 = inspectionUrl;
            }
            const uArr2 = uArr[1];
            this.getCode('Jx3wQMD1', uArr1, uArr2);
        }

        getCode(appId: string, urlTrue: string, urlFalse: string) {
            userApi.obtainCode({appId: appId}).then((r: any) => {
                if(r.data.result == 0){
                    const code = r.data.data;
                    this.url = urlTrue + '?code=' + code + '&returnUrl=' + urlFalse;
                    console.log(this.url);
                }
            })
        }
    }
